import useCheckPermissionsForCurrentCrmOrg from '../../../../common/permissions/useCurrentCrmOrgPermissions';
import ProcessMiningColored from '../process-mining/svg/process-mining-colored.svg?react';
import { usePanels } from '../../../../panels/usePanels';
import { metadataMappingPanelType } from '../process-mining/metadataMappingPanelType';
import { useSelector } from 'react-redux';
import { selectIsFunnelMapEmpty } from '../../../../../reducers/united-canvas/unitedCanvasReducer';
import React, { useCallback, useState } from 'react';
import { Tooltip, colors } from '@sweep-io/sweep-design';
import { ButtonBase } from '@mui/material';
import usePaywall from '../../../../dashboard/paywall/usePaywall';
import { CtaDialog } from '../../../../dashboard/paywall/sales-activated-trial/page/CtaDialog';
import { ActionPaywallSource } from '../../../../dashboard/paywall/paywallTypes';

export const MetadataMappingToolbarButton = ({ disabled }: { disabled?: boolean }) => {
  const permissionStr = 'create:ai-agent:chat';
  const [isAllowedBtn] = useCheckPermissionsForCurrentCrmOrg([permissionStr]);
  const disabledTooltip = isAllowedBtn ? '' : 'To map with AI, please contact your admin.';
  const { maybeOpenPanel, isPanelOpen, maybeCloseSpecificPanel } = usePanels();
  const isFunnelMapEmpty = useSelector(selectIsFunnelMapEmpty);
  const isMetadataMappingPanelOpen = isPanelOpen(metadataMappingPanelType);
  const pressed = isMetadataMappingPanelOpen;
  const { isPaywallActive, sendEncounterPaywallEvent } = usePaywall();
  const [isCtaDialogOpen, setIsCtaDialogOpen] = useState(false);

  const handleToggle = useCallback(() => {
    if (isPaywallActive) {
      sendEncounterPaywallEvent({ source: ActionPaywallSource.METADATA_MAPPING });
      setIsCtaDialogOpen(true);
      return;
    }
    if (pressed) {
      maybeCloseSpecificPanel(metadataMappingPanelType);
    } else {
      maybeOpenPanel({
        panelType: metadataMappingPanelType,
      });
    }
  }, [isPaywallActive, sendEncounterPaywallEvent, maybeOpenPanel, pressed, maybeCloseSpecificPanel]);

  if (isFunnelMapEmpty) {
    return null;
  }

  return (
    <>
      <Tooltip title={disabled ? disabledTooltip : 'Map with AI'} placement="bottom">
        <span>
          <ButtonBase
            onClick={handleToggle}
            disabled={disabled}
            className={pressed ? 'active' : ''}
            sx={{
              width: '32px',
              height: '32px',
              svg: {
                width: '24px',
              },
              '&:hover': {
                backgroundColor: colors.grey[100],
              },
              '&.active': {
                backgroundColor: colors.grey[200],
              },
            }}
          >
            <ProcessMiningColored />
          </ButtonBase>
        </span>
      </Tooltip>
      {isCtaDialogOpen && (
        <CtaDialog name="Map with AI" onClose={() => setIsCtaDialogOpen(false)} />
      )}
    </>
  );
};
